import { Vue, Component } from 'vue-property-decorator'
import HeroComponent from '@/components/hero'

@Component({
  components: {
    HeroComponent
  }
})
export default class VisitorAnalysis extends Vue {

}
